import i18n from "@/i18n";

// Truncate text based on maxLength character limit

/**
 * @description Truncate text based on maxLength character limit and adds a link to allow user to see the full text.
 * @param {el} Host HTML element
 * @param {binding} Vue binding object
 */
export const ReadMoreDirective = {
  bind(el, binding) {
    const maxLength = binding.value && binding.value.maxLength ? binding.value.maxLength : 120;
    const originalText = el.innerHTML;
    const limitToHide = 50;

    if (originalText.length < maxLength) {
      return originalText;
    }

    let trimmedString = originalText.substring(0, maxLength);
    const hiddenText = originalText.substring(maxLength, originalText.length);

    if (hiddenText.length < limitToHide) {
      return;
    }

    //re-trim if we are in the middle of a word
    trimmedString = trimmedString.substring(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")));

    el.innerHTML = trimmedString;

    const toggleTextAnchor = document.createElement('a');
    toggleTextAnchor.className = 'toggle-text-anchor primary--text font-weight-medium';
    toggleTextAnchor.innerHTML = `&nbsp;&nbsp;...${i18n.tc('ReadMoreDirective.ShowMore')}`;

    if (el) {
      el.appendChild(toggleTextAnchor);
      toggleTextAnchor.onclick = showAllText;
    }

    // To allow creating separate HTML elements, customize the same anchor attaching different handler.

    function showAllText(e) {
      e.stopPropagation();
      const anchor = el.getElementsByClassName('toggle-text-anchor')[0];
      anchor.innerHTML = `&nbsp;&nbsp;${i18n.tc('ReadMoreDirective.ShowLess')}`;
      el.innerHTML = originalText;
      el.appendChild(anchor);
      anchor.onclick = truncateText;
    }

    function truncateText(e) {
      e.stopPropagation();
      const anchor = el.getElementsByClassName('toggle-text-anchor')[0];
      anchor.innerHTML = `&nbsp;&nbsp;...${i18n.tc('ReadMoreDirective.ShowMore')}`;
      el.innerHTML = trimmedString;
      el.appendChild(anchor);
      anchor.onclick = showAllText;
    }
  }
};
